import esriConfig from "@arcgis/core/config.js";
esriConfig.assetsPath = "./assets";

import '@arcgis/core/assets/esri/themes/light/main.css';
import "@esri/calcite-components/dist/calcite/calcite.css";

import './styles.scss';

import { checkTokenValidity, init } from './main'

if (checkTokenValidity()) {
    init();
}
else {
    window.location.href ="./noaccess.html"
}